module.exports = __webpack_public_path__ + "img/ylBg.8463156d.png";